import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const SUBJECTS = ['General Inquiry', 'Account Support', 'Trading Question', 'Partnership', 'Media / Press', 'Other']
const COUNTRIES = ['United States', 'United Kingdom', 'United Arab Emirates', 'South Africa', 'Australia', 'New Zealand', 'Seychelles', 'India', 'Mauritius', 'Other']

const FEATURES = [
  { icon: 'shield', title: 'Multi-Jurisdiction Registration', desc: 'Trade with a platform maintaining compliance presence across multiple regulatory jurisdictions.' },
  { icon: 'trendUp', title: 'Competitive Trading Conditions', desc: 'Spreads as low as 0.0 pips, leverage up to 1:1000, and commission-free STD accounts.' },
  { icon: 'download', title: 'Efficient Deposits & Withdrawals', desc: 'No deposit fees, and withdrawals are typically processed within a few hours.' },
]

function ImagePlaceholder({ label, style }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.04)',
      border: '1px dashed rgba(255,255,255,0.2)', borderRadius: '10px', color: 'rgba(255,255,255,0.4)',
      fontSize: '11px', fontFamily: fMono, textAlign: 'center', padding: '12px', ...style,
    }}>
      [ Image placeholder — {label} ]
    </div>
  )
}

export default function Contact() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', country: '', phone: '', subject: '', message: '' })
  const [submitted, setSubmitted] = useState(false)

  const update = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }))

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
  }

  const inputStyle = {
    width: '100%', padding: '11px 14px', fontSize: '13px', border: `1px solid ${C.bdr}`, borderRadius: '8px',
    background: C.white, color: C.tx, fontFamily: fBody, outline: 'none', boxSizing: 'border-box',
  }
  const labelStyle = { fontSize: '12px', fontWeight: 600, color: C.tx2, marginBottom: '6px', display: 'block' }

  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xcf-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .xcf-features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; }
        @media (max-width: 600px) { .xcf-grid { grid-template-columns: 1fr !important; } }
      `}</style>
      <PublicNav active="Company" />

      {/* HERO — light */}
      <section style={{ padding: '130px 24px 40px', textAlign: 'center' }}>
        <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
          <Icon name="contactCard" size={40} strokeWidth={1.5} />
        </div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,40px)', lineHeight: 1.15, margin: '0 0 14px', color: C.tx }}>
          We're Here to Support Your Trading Journey
        </h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, maxWidth: '560px', margin: '0 auto', lineHeight: 1.5 }}>
          Every question and concern you have helps us improve our platform. Feel free to get in touch using the information below.
        </p>
      </section>

      {/* DARK BANNER */}
      <section style={{ padding: '0 24px', maxWidth: '1100px', margin: '0 auto 64px' }}>
        <div style={{
          position: 'relative', borderRadius: '18px', overflow: 'hidden', padding: '36px 40px',
          display: 'flex', alignItems: 'center', minHeight: '180px',
        }}>
          <img src="/assets/images/feedback-banner.jpg" alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(0,0,0,0.85) 40%, rgba(0,0,0,0.35) 100%)' }} />
          <div style={{ position: 'relative', maxWidth: '460px' }}>
            <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(20px,2.5vw,26px)', color: C.ltx, margin: '0 0 10px' }}>Your Feedback Shapes Xperia Capital</h2>
            <p style={{ fontSize: '14px', color: C.ltx2, lineHeight: 1.6, margin: 0 }}>
              Share your feedback, questions, or ideas with us. Your input helps us improve the platform as we grow.
            </p>
          </div>
        </div>
      </section>

      {/* GET IN TOUCH + FORM */}
      <section style={{ padding: '0 24px 72px', maxWidth: '620px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(24px,3vw,30px)', color: C.tx, margin: '0 0 14px' }}>Get in Touch with Us</h2>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: C.primaryDark, fontSize: '14px', fontWeight: 600 }}>
            <Icon name="mail" size={18} />
            Open a support ticket from your dashboard
          </div>
        </div>

        {submitted ? (
          <div style={{ textAlign: 'center', padding: '40px 24px', background: C.light, borderRadius: '14px', border: `1px solid ${C.bdr}` }}>
            <div style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>Message Received</div>
            <p style={{ fontSize: '14px', color: C.tx2, margin: 0 }}>Thanks for reaching out — our team will get back to you shortly.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="xcf-grid">
              <div>
                <label style={labelStyle}>Name*</label>
                <input required value={form.firstName} onChange={update('firstName')} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Last Name*</label>
                <input required value={form.lastName} onChange={update('lastName')} style={inputStyle} />
              </div>
            </div>
            <div className="xcf-grid">
              <div>
                <label style={labelStyle}>Email*</label>
                <input required type="email" value={form.email} onChange={update('email')} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Select Country*</label>
                <select required value={form.country} onChange={update('country')} style={inputStyle}>
                  <option value="" disabled>Select a country</option>
                  {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div className="xcf-grid">
              <div>
                <label style={labelStyle}>Phone*</label>
                <input required type="tel" value={form.phone} onChange={update('phone')} placeholder="+1 234 567 8900" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Subject</label>
                <select value={form.subject} onChange={update('subject')} style={inputStyle}>
                  <option value="" disabled>Choose subject</option>
                  {SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div>
              <label style={labelStyle}>Message</label>
              <textarea rows={5} value={form.message} onChange={update('message')} placeholder="Your message..." style={{ ...inputStyle, resize: 'vertical' }} />
            </div>
            <button type="submit" style={{
              alignSelf: 'flex-start', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '14px',
              padding: '12px 32px', borderRadius: '999px', border: 'none', cursor: 'pointer',
            }}>Submit</button>
          </form>
        )}
      </section>

      {/* FEATURES */}
      <section style={{ padding: '0 24px 72px', maxWidth: '1000px', margin: '0 auto' }}>
        <div className="xcf-features-grid">
          {FEATURES.map(f => (
            <div key={f.title} style={{ background: C.light, border: `1px solid ${C.bdr}`, borderRadius: '14px', padding: '22px' }}>
              <div style={{ color: C.primary, marginBottom: '12px' }}><Icon name={f.icon} size={26} strokeWidth={1.5} /></div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '16px', color: C.tx, marginBottom: '6px' }}>{f.title}</div>
              <p style={{ fontSize: '13px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA BANNER — dark, branded image */}
      <section style={{ background: C.dark, position: 'relative', height: '200px', overflow: 'hidden' }}>
        <img src="/assets/images/cta-start-trading-v2.jpg" alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'relative', height: '100%', display: 'flex', alignItems: 'center', padding: '0 40px' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(24px,3.5vw,34px)', color: C.ltx, margin: 0 }}>
            Start <span style={{ color: C.primary }}>Trading</span> Today
          </h2>
        </div>
      </section>
      <div style={{ padding: '28px 24px', textAlign: 'center', background: C.dark }}>
        <Link to="/signup" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 26px', borderRadius: '999px', textDecoration: 'none' }}>Create an Account</Link>
      </div>

      <PublicFooter />
    </div>
  )
}
